<script setup lang="ts">
import { computed } from 'vue';
import { get } from 'lodash-es';
import type { IColumnDefinition, ITextColumn, RowData } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const displayValue = computed(() => {
  const col = props.column as ITextColumn;

  if (col.path) {
    return get(props.row, col.path);
  }

  const val = props.value;
  if (val !== null && typeof val === 'object') {
    if (val.name) {
      return val.name;
    }
    if (val.label) {
      return val.label;
    }
    if (val.text) {
      return val.text;
    }
    if (val.title) {
      return val.title;
    }
    return JSON.stringify(val);
  }

  return val;
});
</script>

<template>
  <span class="itp-text-formatter">
    {{ displayValue }}
  </span>
</template>
